import { render, staticRenderFns } from "./person.vue?vue&type=template&id=f9740956&scoped=true"
import script from "./person.vue?vue&type=script&lang=js"
export * from "./person.vue?vue&type=script&lang=js"
import style0 from "./person.vue?vue&type=style&index=0&id=f9740956&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9740956",
  null
  
)

export default component.exports